import { useState } from "react";
import "./editorialForms.css";

export default function LiveAudioForm({ data, onChange }) {
  const [topics, setTopics] = useState(data?.topics?.join(", ") || "");

  const handleTopicsChange = (e) => {
    const value = e.target.value;
    setTopics(value);
    const topicsArray = value
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t.length > 0);
    onChange({ ...data, topics: topicsArray });
  };

  return (
    <div className="editorial_form live_audio_form">
      <div className="editorial_form_section">
        <label>
          Nome da Sala <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Bate-papo sobre tecnologia"
          value={data?.roomName || ""}
          onChange={(e) => onChange({ ...data, roomName: e.target.value })}
          maxLength={100}
        />
        <span className="editorial_form_counter">
          {(data?.roomName?.length || 0)}/100
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Descreva o tema da sua sala de audio..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={500}
          rows={3}
        />
        <span className="editorial_form_counter">
          {(data?.description?.length || 0)}/500
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Topicos (separados por virgula)</label>
        <input
          type="text"
          placeholder="tecnologia, startups, inovacao"
          value={topics}
          onChange={handleTopicsChange}
        />
      </div>

      <div className="editorial_form_section">
        <label>Agendar para</label>
        <input
          type="datetime-local"
          value={data?.scheduledAt || ""}
          onChange={(e) => onChange({ ...data, scheduledAt: e.target.value })}
        />
        <span className="editorial_form_hint">
          Deixe vazio para iniciar imediatamente
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Configuracoes</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="recordRoom"
            checked={data?.shouldRecord || false}
            onChange={(e) =>
              onChange({ ...data, shouldRecord: e.target.checked })
            }
          />
          <label htmlFor="recordRoom">Gravar sala</label>
        </div>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="requestToSpeak"
            checked={data?.requestToSpeak !== false}
            onChange={(e) =>
              onChange({ ...data, requestToSpeak: e.target.checked })
            }
          />
          <label htmlFor="requestToSpeak">
            Participantes precisam pedir para falar
          </label>
        </div>
      </div>

      <div className="editorial_form_tip live_audio_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
        </svg>
        <span>
          Crie uma sala de audio ao vivo onde os participantes podem entrar e
          conversar. Voce sera o anfitriao.
        </span>
      </div>

      <div className="editorial_form_section">
        <div className="live_audio_actions">
          <div className="live_info_box">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
            </svg>
            <div>
              <strong>Como funciona:</strong>
              <p>Apos publicar, a sala sera criada e voce podera permitir que outros usuarios entrem e participem da conversa.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
